var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37833 11.2858C7.41833 15.295 10.705 18.5675 14.7142 20.6217L17.8308 17.505C18.2133 17.1225 18.78 16.995 19.2758 17.165C20.8625 17.6892 22.5767 17.9725 24.3333 17.9725C25.1125 17.9725 25.75 18.61 25.75 19.3892V24.3333C25.75 25.1125 25.1125 25.75 24.3333 25.75C11.0308 25.75 0.25 14.9692 0.25 1.66667C0.25 0.8875 0.8875 0.25 1.66667 0.25H6.625C7.40417 0.25 8.04167 0.8875 8.04167 1.66667C8.04167 3.4375 8.325 5.1375 8.84916 6.72417C9.005 7.22 8.89167 7.7725 8.495 8.16917L5.37833 11.2858Z",
    fill: "#01A944"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGreen);
export default __webpack_public_path__ + "static/media/phoneGreen.9a64bea5.svg";
export { ForwardRef as ReactComponent };